import { WidgetSettings } from '@gsc/types'
import { IRuntime, IRuntimeSettings } from './interfaces'
import { createRuntime } from './runtime'
import { createWidgetRenderer } from './widgets'
import { fixPrototypeJsToJSONBug } from './quirks'

fixPrototypeJsToJSONBug()

const initializeRuntime = (() => {
  let promise: Promise<IRuntime>
  return (settings: IRuntimeSettings): Promise<IRuntime> => {
    if (!promise) {
      promise = createRuntime({ createWidgetRenderer }, settings)
    }
    return promise
  }
})()

interface Settings {
  runtime?: Partial<IRuntimeSettings>
  widgets?: WidgetSettings[]
}

interface WidgetApi {
  (...args: unknown[]): unknown

  q?: unknown[][]
  start?: (settings: Settings) => void
}

let runtime: IRuntime
const ctx: any = window

const widgetApi: WidgetApi = function (...args: unknown[]) {
  if (!runtime) {
    widgetApi.q.push(args)
    return
  }
  return runtime.apiCall(args)
}

widgetApi.q = []

widgetApi.start = async ({ runtime: runtimeSettings, widgets = [] }: Settings = {}) => {
  const isIE = !!ctx.document.documentMode
  if (isIE) {
    return // IE not supported
  }

  if (!runtime) {
    runtime = await initializeRuntime(runtimeSettings)
  }

  runtime.run(widgets)

  if (widgetApi.q) {
    widgetApi.q.forEach(args => widgetApi(...args))
    delete widgetApi.q
  }
}

const api: WidgetApi = ctx[LIBRARY]

if (!api || !api.start) {
  const q = (api && api.q) || []
  widgetApi.q = [...q]
  ctx[LIBRARY] = widgetApi
}

if (module.hot) {
  module.hot.accept()
}
